import React, { Component } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import _ from 'lodash';

import BusinessDeveplomentList from './list.jsx';
import BusinessDeveplomentForm from './form.jsx';
import SystemMsg from '../common/system-msg.jsx';
import 'assets/css/business-development.css';

class BusinessDeveploment extends Component {
  constructor(props) {
    super(props);
    const { user } = this.props.session;
    let permissions = null;

    if (user && user.role && user.role.permissions) {
      user.role.permissions.forEach((area) => {
        if (area.area === 'business_development') {
          permissions = area;
        }
      });
    }
    this.state = {
      permissions,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!_.isEqual(this.props.session, nextProps.session)) {
      const { user } = nextProps.session;
      let permissions = null;

      if (user && user.role && user.role.permissions) {
        user.role.permissions.forEach((area) => {
          if (area.area === 'business_development') {
            permissions = area;
          }
        });
      }

      this.setState({ permissions });
    }
  }

  componentWillUnmount() {
    this.props.businessDevelopmentHideForm();
    this.props.businessDevelopmentShowList();
  }

  getTitle() {
    if (this.props.businessDevelopment.showList) {
      return (
        <Row>
          <Col xs={12} className="title-section">
            <h1 className="box-title">
              Business Development &raquo; Pipedrive Active Deals
            </h1>
            {
              this.state.permissions && this.state.permissions.can_create ?
                <Button bsSize="small" bsStyle="success" onClick={this.props.businessDevelopmentShowForm.bind(this, "newItem")}>Add New</Button>
                : null
            }
          </Col>
        </Row>
      );
    }

    if (this.props.businessDevelopment.showForm) {
      return (
        <div>
          <Row>
            <Col xs={12}>
              <Button
                bsSize="xsmall"
                onClick={this.props.businessDevelopmentShowList.bind(this)}
              >
                <span className="fa fa-arrow-circle-o-left" />
                &nbsp;Back
              </Button>
            </Col>
          </Row>
          <Row>
            <Col xs={12} className="title-section">
              <h1 className="box-title">
                {this.props.businessDevelopment.itemId ? 'Edit Business Development' : 'Add New Business Development'}
              </h1>
            </Col>
          </Row>
        </div>
      );
    }

    return '';
  }

  render() {
    if (
      !this.state.permissions
      || (
        !this.state.permissions.can_read
        && !this.state.permissions.can_create
        && !this.state.permissions.can_delete
        && !this.state.permissions.can_update
        && !this.state.permissions.limit_to_own_user
      )
    ) {
      if (this.state.permissions) {
        this.props.router.push('/404');
      }
      return null;
    }

    return (
      <section className={`business-development-content ${this.props.businessDevelopment.showList ? 'minWidth' : ''}`}>
        { this.props.businessDevelopment.inProgress ? <SystemMsg msg="Loading" hasSpinner /> : '' }
        <div className="box">
          <div className="box-header with-border">
            {this.getTitle()}
          </div>
          <div className="box-content">
            {this.props.businessDevelopment.showList ? <BusinessDeveplomentList permissions={this.state.permissions} {...this.props} /> : ''}
            {this.props.businessDevelopment.showForm ? <BusinessDeveplomentForm permissions={this.state.permissions} {...this.props} /> : ''}
          </div>
        </div>
      </section>
    );
  }
}

export default BusinessDeveploment;
